import { Controller } from "@hotwired/stimulus"

const BODY_LOCK_CLASS = "modal-locked"
let activeLocks = 0
let storedScrollY = 0

function lockBodyScroll() {
  if (typeof window === "undefined" || typeof document === "undefined") return

  if (activeLocks === 0) {
    storedScrollY = window.scrollY || document.documentElement.scrollTop || 0
    document.documentElement.classList.add(BODY_LOCK_CLASS)
    document.body.classList.add(BODY_LOCK_CLASS)
    document.body.style.position = "fixed"
    document.body.style.top = `-${storedScrollY}px`
    document.body.style.width = "100%"
  }

  activeLocks += 1
}

function unlockBodyScroll() {
  if (typeof window === "undefined" || typeof document === "undefined") return
  if (activeLocks === 0) return

  activeLocks -= 1
  if (activeLocks === 0) {
    document.documentElement.classList.remove(BODY_LOCK_CLASS)
    document.body.classList.remove(BODY_LOCK_CLASS)
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.width = ""
    window.scrollTo(0, storedScrollY)
  }
}

// Connects to data-controller="custom-modal"
export default class extends Controller {
  static targets = ["overlay", "panel"]
  static values = { autoOpen: Boolean }

  connect() {
    this.modalOpen = false
    this.boundScrollGuard = (event) => this.guardModalScroll(event)
    this.scrollGuardOptions = { passive: false }
    this.attachScrollGuards()

    if (this.hasOverlayTarget) {
      this.overlayTarget.addEventListener("openCustomModal", this.openCustomModal)
    }

    if (this.hasAutoOpenValue && this.autoOpenValue) {
      requestAnimationFrame(() => this.openCustomModal())
    }
  }

  disconnect() {
    this.detachScrollGuards()
    this.releaseBodyLock()
    if (this.hasOverlayTarget) {
      this.overlayTarget.removeEventListener("openCustomModal", this.openCustomModal)
    }
  }

  openCustomModal = () => {
    if (this.modalOpen || !this.hasOverlayTarget || !this.hasPanelTarget) return

    this.modalOpen = true
    this.overlayTarget.classList.add("show")
    this.panelTarget.classList.add("show")
    this.applyBodyLock()
  }

  closeCustomModal() {
    if (!this.hasOverlayTarget || !this.hasPanelTarget) return

    this.modalOpen = false
    this.overlayTarget.classList.remove("show")
    this.panelTarget.classList.remove("show")
    this.releaseBodyLock()
  }

  applyBodyLock() {
    if (this.bodyLocked) return
    lockBodyScroll()
    this.bodyLocked = true
  }

  releaseBodyLock() {
    if (!this.bodyLocked) return
    unlockBodyScroll()
    this.bodyLocked = false
  }

  attachScrollGuards() {
    if (!this.hasPanelTarget || this.scrollGuardAttached) return

    this.panelTarget.addEventListener("wheel", this.boundScrollGuard, this.scrollGuardOptions)
    this.panelTarget.addEventListener("touchmove", this.boundScrollGuard, this.scrollGuardOptions)
    this.scrollGuardAttached = true
  }

  detachScrollGuards() {
    if (!this.hasPanelTarget || !this.scrollGuardAttached) return

    this.panelTarget.removeEventListener("wheel", this.boundScrollGuard, this.scrollGuardOptions)
    this.panelTarget.removeEventListener("touchmove", this.boundScrollGuard, this.scrollGuardOptions)
    this.scrollGuardAttached = false
  }

  guardModalScroll(event) {
    if (!this.modalOpen) return

    event.stopImmediatePropagation()
  }
}
